import { FC } from 'react';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};
const codeSample = `
const parent = await channel.sendMessage({
  text: 'Episode 1 just blew my mind!',
});

const reply = await channel.sendMessage({
  text: "Stop it, no spoilers please!",
  parent_id: parent.message.id,
  customField: 123, // custom field, you can add as many as you want
});
`;

export const Step6: FC<Props> = ({ setComplete, content }) => {
  const { startThread } = useChatContext();

  const run = async () => {
    await startThread();
    setComplete(6, 5);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code language="jsx" footer={{ label: 'Start a Thread', run }}>
          {codeSample}
        </Code>
      }
    />
  );
};
